import { render, staticRenderFns } from "./kpi-c.vue?vue&type=template&id=08aeceb6&scoped=true"
import script from "./kpi-c.vue?vue&type=script&lang=ts"
export * from "./kpi-c.vue?vue&type=script&lang=ts"
import style0 from "./kpi-c.vue?vue&type=style&index=0&id=08aeceb6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aeceb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08aeceb6')) {
      api.createRecord('08aeceb6', component.options)
    } else {
      api.reload('08aeceb6', component.options)
    }
    module.hot.accept("./kpi-c.vue?vue&type=template&id=08aeceb6&scoped=true", function () {
      api.rerender('08aeceb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-c/kpi-c.vue"
export default component.exports